import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_card_text = _resolveComponent("v-card-text")
  const _component_v_card = _resolveComponent("v-card")
  const _component_v_col = _resolveComponent("v-col")
  const _component_v_row = _resolveComponent("v-row")
  const _component_v_container = _resolveComponent("v-container")

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "fill-height",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        align: "center",
        justify: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            align: "center",
            justify: "center"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sortedGigs, (gig) => {
                return (_openBlock(), _createBlock(_component_v_card, {
                  class: "mx-auto my-12",
                  key: `${gig.date}-${gig.venue}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, {
                      class: _normalizeClass(["text-center", { 'gig-played': $options.isPlayed(gig) }]),
                      align: "center",
                      justify: "center"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(gig.displayDate) + " - " + _toDisplayString(gig.venue), 1),
                        (gig.bands.length)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" with " + _toDisplayString(gig.bands.join(' + ')), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["class"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}